import { Component, OnInit, OnDestroy, ChangeDetectorRef, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { IonContent, NavController, ModalController } from '@ionic/angular';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { AuftragEx } from 'src/app/api/model/model';
import { AuftragsFormular, StatusmeldungZusatzinfo, WorkflowStatus } from 'src/app/api/model/swagger-model';
import { SystemService } from 'src/app/api/system.service';
import { StammdatenService } from 'src/app/api/stammdaten.service';
import { AppConfig } from 'src/app/api/helper/app.config';
import { UiHelper } from 'src/app/api/helper/ui-helper';
import { delay } from 'rxjs/operators';
import { MyApp } from 'src/app/api/helper/app';
import { Utils } from 'src/app/api/helper/utils';

const log = new Logger('StatuszusatzinfoModalPage');

@Component({
    selector: 'app-statuszusatzinfo-modal',
    templateUrl: './statuszusatzinfo-modal.page.html',
    styleUrls: ['./statuszusatzinfo-modal.page.scss'],
    standalone: false
})
export class StatuszusatzinfoModalPage implements OnInit, OnDestroy {

    @ViewChild('content', { read: IonContent, static: true }) content: IonContent;

    @Input() auftrag: AuftragEx = null;
    @Input() workflowStatus: WorkflowStatus = null;

    felder: FeldVO[] = [];

    subscriptions: Subscription[] = [];

    formularKonfiguration: AuftragsFormular;

    isVisible = false;

    app = MyApp.current;

    constructor(
        private route: ActivatedRoute,
        private systemService: SystemService,
        private modalController: ModalController,
        private cdr: ChangeDetectorRef,
        private stammdatenService: StammdatenService,
        private router: Router,
        private nav: NavController) { }

    ngOnInit() {
        this.felder = [];

        if (!this.workflowStatus.statuszusatzinfo) {
            return;
        }

        if (this.workflowStatus.statuszusatzinfo.Felder) {
            for (const feld of this.workflowStatus.statuszusatzinfo.Felder) {
                if (!feld.Typ) {
                    feld.Typ = 'text';
                }

                const vo = {
                    Key: feld.Key,
                    Bezeichnung: feld.Bezeichnung,
                    Typ: feld.Typ,
                    Wert: null,
                    Erforderlich: feld.Erforderlich
                };

                if (feld.Typ === 'checkbox') {
                    vo.Wert = false;
                }

                if (feld.StandardWert != null && feld.StandardWert != '') {
                    if (feld.Typ === 'checkbox') {
                        vo.Wert = Utils.isTrue(feld.StandardWert);
                    } else if (feld.Typ === 'ganzzahl') {
                        vo.Wert = Utils.parseInt(feld.StandardWert);
                    } else if (feld.Typ === 'dezimalzahl') {
                        vo.Wert = Utils.parseFloat(feld.StandardWert);
                    } else {
                        vo.Wert = feld.StandardWert;
                    }
                }

                this.felder.push(vo);
            }
        }
    }

    ngOnDestroy() {
        log?.debug('ngOnDestroy');

        this.subscriptions.forEach(p => p.unsubscribe());
        this.subscriptions = [];
    }

    async ionViewWillEnter() {
        log?.debug('ionViewWillEnter');
        this.isVisible = true;
        this.updateView();
    }

    async ionViewDidEnter() {
        log?.debug('ionViewDidEnter');

        await delay(400);

        const firstInput: any = document.querySelector('.zusatzinfo-content input');

        if (firstInput) {
            firstInput.focus();
        }
    }

    ionViewWillLeave() {
        log?.debug('ionViewWillLeave');
        this.isVisible = false;
    }

    async updateView() {
        if (!this.isVisible) {
            return;
        }

        log?.debug('updateView');

        if (!this.auftrag) {
            this.dismiss();
            return;
        }

        log?.debug('after updateView', {
            auftrag: this.auftrag,
            formularKonfiguration: this.formularKonfiguration
        });

        const appConfig = AppConfig.current;

        if (appConfig.einstellungen) {
            if (appConfig.einstellungen.Farbe1) {
                if (this.content) {
                    const toolbarElement = (this.content as any).el;
                    toolbarElement.style.setProperty('--background', appConfig.einstellungen.Farbe1);
                }
            }
        }

        this.cdr.detectChanges();
    }


    dismiss() {
        // using the injected ModalController this page
        // can "dismiss" itself and optionally pass back data
        this.modalController.dismiss({
            'dismissed': true
        });
    }

    async onOK() {
        log?.debug('onOK');

        for (const vo of this.felder) {
            if (vo.Erforderlich) {
                if (vo.Wert === null || vo.Wert === '') {
                    UiHelper.showAlert(`Bitte '${vo.Bezeichnung}' eingeben`);
                    return;
                }

                if (vo.Typ === 'checkbox') {
                    if (!vo.Wert) {
                        UiHelper.showAlert(`'${vo.Bezeichnung}' ist erforderlich`);
                        return;
                    }
                }
            }
        }

        const zusatzinfo: StatusmeldungZusatzinfo = {
            Felder: []
        }

        for (const vo of this.felder) {
            let wert = vo.Wert;

            if (vo.Typ === 'checkbox') {
                if (wert) {
                    wert = 'ja';
                } else {
                    wert = 'nein';
                }
            }

            if (vo.Typ === 'uhrzeit') {
                if (wert && typeof (wert) === 'string' && wert.length > 10) {
                    const m = Utils.parseDatum(wert);
                    wert = m.format('HH:mm');
                }
            }

            zusatzinfo.Felder.push({
                Key: vo.Key,
                Bezeichnung: vo.Bezeichnung,
                Wert: wert
            })
        }

        this.modalController.dismiss({
            'dismissed': true,
            'zusatzinfo': zusatzinfo
        });
    }

    onAbbrechen() {
        log?.debug('onAbbrechen');
        this.dismiss();
    }
}

interface FeldVO {
    Key: string;
    Bezeichnung: string;
    Typ: string;
    Wert: any;
    Erforderlich: boolean;
}